import { Trans, useTranslation } from "react-i18next";

import util from "utils/utils";

import type { NotificationContentProps } from "../../types";

export default function IdeaSubmittedContent({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  context,
  status,
}: NotificationContentProps) {
  const { t } = useTranslation();
  return (
    <Trans
      i18nKey="notifications.ideaSubmitted"
      values={{
        name: util.getEventNames(events ?? []),
        ideaLabel: events.length > 1 ? t("generic.ideas") : t("generic.idea"),
        ideas: events.map((e) => e.ownerIdea?.name || "Deleted").join(" "),
        challenge: ownerChallenge?.name || "Deleted",
      }}
    />
  );
}
